module.exports = __webpack_public_path__ + "img/img_header.fa21afe0.png";